import { useNavigate } from "react-router-dom";

import { useVulnerabilityContext } from "../../../context/vulnerability/useVulnerabilityContext";
import { ABOUT_ROUTES, PATHS } from "../../../config/routeConfig";
import MultipleChoiceQuestion from "../../../components/Questions/MultipleChoiceQuestion";
import { questionContent } from "../questions";
import { CustomerSupportVulnerabilityCircumstanceSightInput } from "../../../generated/customer/schema.graphql";

type SightQuestion = Record<keyof CustomerSupportVulnerabilityCircumstanceSightInput, string>;

export const sightQuestions: SightQuestion = {
  mildVisualImpairment: "Mild visual impairment",
  moderateVisualImpairment: "Moderate visual impairment",
  severeVisualImpairment: "Severe visual impairment",
  legallyBlind: "Legally blind",
};

const SightDetail: React.FC = () => {
  const { answers, setAnswers } = useVulnerabilityContext();
  const navigate = useNavigate();

  const onChange = (newAnswers: Record<string, boolean>) => {
    setAnswers({
      ...answers,
      sightDetail: newAnswers,
    });
  };

  const onContinue = () => {
    navigate(`/${PATHS.About}/${ABOUT_ROUTES.Hearing}`);
  };

  return (
    <MultipleChoiceQuestion
      onChange={onChange}
      options={sightQuestions}
      values={answers.sightDetail}
      onContinue={onContinue}
      step={questionContent.sightDetail.step}
      title={questionContent.sightDetail.title}
      subTitle={questionContent.sightDetail.subTitle}
      whyWeWantTexts={questionContent.sightDetail.whyWeWantTextsCustomer}
      requireAnswer
    />
  );
};

export default SightDetail;
